import { BillingIcon, ErrorIcon } from "allIcons";
import "./index.css";
import PrimaryHeading from "commonUI/PrimaryHeading";
import MainButton from "commonUI/MainButton";
import { t } from "i18next";
import LoadingIndicator from "./LoadingIndicator";

export default function LimitReachedCard({ title, description, show = false, isLoading = false}) {

  if (!show) return <></>;
  if (isLoading) return <LoadingIndicator />
  return (
    <>
      <div className="limit-reached">
        <div className="limit-reached-icon">
          <ErrorIcon />
        </div>
        <div className="text-center">
          <PrimaryHeading className="text-14">{title}</PrimaryHeading>
          <p className="body-text m-0 text-center">{description}</p>
        </div>
        <a
          href="https://wpsitelauncher.com/customer-dashboard/?action=index&model=subscription"
          target="_blank"
          rel="noreferrer"
        >
          <MainButton className="limit-reached-manage-plan-button">
            <BillingIcon fill="white" />
            {t("common.button.managePlan")}
          </MainButton>
        </a>
      </div>
    </>
  );
}
